<template>
    <div>
        <SealedEnvelopeBallot page_type="seb" />
    </div>
</template>

<script>
    import SealedEnvelopeBallot from '@/components/Sealed-envelope-ballot.vue';

export default {
        components: { SealedEnvelopeBallot }
}
</script>

<style>

</style>
